import axios, { AxiosRequestConfig } from 'axios'
import { createSign, isNewBridgeView } from '@/assets/js/utils.js'
import { Toast, Dialog } from 'vant'
import { v4 as uuidv4 } from 'uuid'
import { goLogin } from '@/utils/nativeFn'
export interface McAxiosRequestConfig extends AxiosRequestConfig {
  extraConfig?: {
    tokenRetryCount: number
  }
}
axios.defaults.timeout = 15000
const config: McAxiosRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
    'x-aio-appid': process.env.VUE_APP_ID,
    client: 'web',
    source: 4,
    channel: 1
  }
}
const instance = axios.create(config)

instance.interceptors.request.use(async (config: McAxiosRequestConfig) => {
  const tal_token = window.localStorage.getItem('tal_token') || ''
  const userId = window.localStorage.getItem('TAL_UID_TMP') || ''

  //服务版本，兼容老域名，中盘28，默认1
  const hostname = window.location.hostname
  const default_services_version = hostname.includes('xesvip.cn') ? 28 : 1
  const services_version = localStorage.getItem('service_version') || default_services_version

  const {
    token = tal_token,
    user_id = userId,
    service_version_name = '1.10.100',
    service_version = services_version
  } = JSON.parse(localStorage.getItem('clientCommonMessage') || '{}')
  config.headers['token'] = token
  config.headers['client-version'] = `v${service_version_name}`
  config.headers['services-version'] = service_version
  config.headers['uid'] = user_id
  // 请求时更新这个值
  ;(config.headers['time'] = Date.parse(new Date().toString()) / 1000),
    (config.headers['x-aio-trace-id'] = uuidv4().replaceAll('-', ''))
  // 接口签名
  let sign = createSign(config)
  config.headers['sign'] = sign
  if (!config.extraConfig?.tokenRetryCount) {
    config.extraConfig = {
      tokenRetryCount: 0
    }
  }
  config.url = process.env.VUE_APP_API_URL + config.url
  return config
})

instance.interceptors.response.use(
  (response) => {
    if (response.data.code === 100101) {
      Dialog.alert({
        message: response.data.message,
        confirmButtonText: '去登录'
      }).then(() => {
        if (isNewBridgeView()) {
          goLogin({}, (res) => {
            console.log('跳登录', res)
          })
        } else {
          window['$mobileNativeSDK'].goLogin()
        }
      })
      return
    }
    return response
  },
  async (err) => {
    if (axios.isCancel(err)) {
      //取消请求，不报错
      return
    }
    if (err.message === 'Network Error') {
      Toast('网络不佳，请稍后再试')
      return
    }
    if (err.message.includes('timeout')) {
      Toast('请求超时，请稍后再试')
      return Promise.reject(err.message)
    }
    if (err.response?.status >= 500) {
      return
    }
    const { data: responseData } = err.response || {}
    const { status } = responseData || {}
    // if (status) {
    //   switch (parseInt(status)) {
    //     case 401:
    //       break;
    //     default:
    //       break;
    //   }
    // }
    // if (err.response.status !== 200) {
    //   Promise.reject(err.response)
    // }
    return Promise.reject(err.response)
  }
)

export default instance
